import React from 'react'

const TrayManagementTableComponentLoadable = React.lazy(() => import('./TrayManagementTableComponent'))

export {
	TrayManagementTableComponentLoadable
}